import { Europafacts } from "@/services/api";
import type { Country } from "@/types/europafacts";
import type { CountryStore } from "@/types/stores/country";
import { createAsyncLoader } from "@/utils/stores/asyncLoader";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

const preloadedImages = new Set<string>();

function preloadFlagImages(countries: Country[]): void {
  countries.forEach((country) => {
    if (country.flag_file && !preloadedImages.has(country.flag_file)) {
      const img = new window.Image();
      img.src = country.flag_file;
      preloadedImages.add(country.flag_file);
    }
  });
}

const initialState = {
  countries: [],
  isLoadingCountries: false,
  countriesPromise: null,
};

export const useCountryStore = create<CountryStore>()(
  devtools(
    (set, get) => ({
      ...initialState,

      loadCountries: createAsyncLoader({
        loadFn: () => Europafacts.getCountries(),
        dataKey: "countries",
        loadingKey: "isLoadingCountries",
        promiseKey: "countriesPromise",
        actionName: "country/loadCountries",
        transform: (countries) => {
          const filtered = countries.filter((country) => country.flag_file);
          preloadFlagImages(filtered);
          return filtered;
        },
        onError: () => [],
      })(set, get),
    }),
    {
      name: "country-store",
    }
  )
);

export const useCountries = () => useCountryStore((state) => state.countries);

export const useIsLoadingCountries = () =>
  useCountryStore((state) => state.isLoadingCountries);

export const useLoadCountries = () =>
  useCountryStore((state) => state.loadCountries);

